import { FC } from 'react';

import Link from 'next/link';

import { Checkbox, Flex } from 'antd';

import { useDocsList } from '@/api/docs';

import styles from './PersonalDataConfirm.module.scss';

type Props = {
	checked: boolean;
	onCheckedChange: (value: boolean) => void;
};

export const PersonalDataConfirm: FC<Props> = ({ checked, onCheckedChange }) => {
	const { data } = useDocsList();
	const policy = data?.find((d) => d.title_en === 'privacy_policy');
	return (
		<Flex gap={8} align="start">
			<Checkbox onChange={(e) => onCheckedChange(e.target.checked)} checked={checked} />
			<div className={styles.text}>
				Я даю согласие на обработку моих персональных данных в соответствии с{' '}
				<Link href={policy?.file ?? ''} className={styles.link}>
					Политикой конфиденциальности
				</Link>
			</div>
		</Flex>
	);
};
